export default __webpack_public_path__ + "static/media/biote_zure.3235a63e.png";